import {
  TV_SCALE_ANCHOR_WIDTH,
  TV_SCALE_BOARD_COUNT_DAMPING,
  TV_SCALE_MAX,
} from './boardConstants';

export const scaleSizes = (sizes, scaleFactor) => Object.fromEntries(
  Object.entries(sizes).map(([key, base]) => [key, Math.round(base * scaleFactor)]),
);

/**
 * Raw up/down only — better/worse (e.g. a lower sprint time) is shown by color
 * from changeDirection. The API may send decimal values as strings.
 */
export const getChangeArrow = (rawValue, compareRawValue) => {
  if (rawValue == null || compareRawValue == null) return '';
  const diff = Number(rawValue) - Number(compareRawValue);
  if (diff > 0) return '▲ ';
  if (diff < 0) return '▼ ';
  return '';
};

// Computed once per board in Board.js and passed down — see BEHAVIOR.md Invariants.
export const computeScaleFactor = ({ isTvMode, boardWidth, activeBoards }) => {
  if (!isTvMode) return 1;
  const anchorForBoardCount = TV_SCALE_ANCHOR_WIDTH
    / (1 + (activeBoards - 1) * TV_SCALE_BOARD_COUNT_DAMPING);
  return Math.min(TV_SCALE_MAX, Math.max(1, boardWidth / anchorForBoardCount));
};

const groupIds = (arr) => [...(arr || [])].map((g) => g.id).sort().join(',');
const dateStr = (d) => `${d?.startDate ?? ''}|${d?.endDate ?? ''}`;
// Older templates were saved with category 'cardio' instead of 'R'.
export const normalizeCategory = (cat) => (cat === 'cardio' ? 'R' : cat);

// A blank Groups selection means "every group the user can access"; resolve it
// before submitting or comparing against a template so all of those agree.
export const resolveSubmitGroups = (selectedGroups, allGroups) => (
  selectedGroups && selectedGroups.length > 0 ? selectedGroups : allGroups
);

export const findDuplicateTemplate = (formValues, templates, excludeId = null) => templates.find(
  (t) => {
    if (excludeId !== null && t.id === excludeId) return false;
    return (
      normalizeCategory(formValues.category) === normalizeCategory(t.category)
      && formValues.exerciseId === t.exerciseId
      && !!formValues.mustBeInAllGroups === !!t.mustBeInAllGroups
      && Number(formValues.gender) === Number(t.gender)
      && formValues.rangeType === t.rangeType
      && formValues.compareTo === t.compareTo
      && groupIds(formValues.groups) === groupIds(t.groups)
      && dateStr(formValues.rangeDates) === dateStr(t.rangeDates)
      && dateStr(formValues.compareDates) === dateStr(t.compareDates)
    );
  },
) || null;

export const filterAndSortByGroups = (templates, selectedGroups) => {
  if (!selectedGroups || selectedGroups.length === 0) return templates;

  const withRatio = templates.map((t) => {
    const matched = selectedGroups.filter(
      (sg) => t.groups.some((g) => g.id === sg.id),
    ).length;
    return { t, ratio: matched / selectedGroups.length };
  });

  return withRatio
    .filter(({ ratio }) => ratio > 0)
    .sort((a, b) => b.ratio - a.ratio || a.t.exerciseName.localeCompare(b.t.exerciseName))
    .map(({ t }) => t);
};
